<div>
  Please proceed to add users and then create your first project.
</div>
<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="onClose()">Continue</button>
</div>
